import Phaser from 'phaser';
import { gameConfig } from './config';
import { serializeLog, resetLog, getLogEntries } from './systems/runLog';

// Single Phaser game instance, mounted into the #game div in index.html.
new Phaser.Game(gameConfig);

// Debug helper: window.rogueLog.copy() — prints and copies the run event log.
// window.rogueLog.clear() — resets the log (auto-reset on new run).
(window as unknown as Record<string, unknown>).rogueLog = {
  copy() {
    const text = serializeLog();
    navigator.clipboard.writeText(text).then(
      () => console.log('[rogueLog] Copied', getLogEntries().length, 'events to clipboard.'),
      () => console.log('[rogueLog] Clipboard unavailable — log printed above.\n\n' + text),
    );
    console.log(text);
    return text;
  },
  clear() {
    resetLog();
    console.log('[rogueLog] Log cleared.');
  },
  get entries() {
    return getLogEntries();
  },
};
